import { Inject, Injectable } from '@angular/core';
import { StateService, UIRouter } from '@uirouter/angular';
import { StateHistoryService } from './state-history.service';

/**
 * The service for managing state location.
 *  Contains all the methods needed for state location handling.
 */
@Injectable({
  providedIn: 'root'
})
export class StateLocationService {

  preventCall: any[] = [];

  constructor(
    private router: UIRouter,
    private $state: StateService,
    @Inject(StateHistoryService) private stateHistoryService: StateHistoryService
  ) {
  }

  locationChange() {
    let entry;
    let poppedValue = this.preventCall.pop();
    if (!_.isUndefined(poppedValue) && !_.isNull(poppedValue) && poppedValue == 'locationChange') {
      return;
    }
    if (this.router.urlService.url() == "" || this.router.urlService.url() == "/") {
      this.preventCall.push('stateChange');
      this.$state.go('login', null, { reload: true });
      return;
    }
    entry = this.stateHistoryService.get(this.router.urlService.url());
    if (this._isMissingEntry(entry)) {
      // if(this.$location.url() == '/login') {
      //     this.preventCall.push('stateChange');
      // }
      if (this._currentScreenDoesNotRequireLogin()) {
        return this.router.urlService.url();
      }
      if (this._currentUrlIsInvalid()) {
        this.$state.go('login', null, { reload: true });
        return;
      }
      return;
    }
    this.preventCall.push('stateChange');
    return this.$state.go(entry.name, entry.params, {
      location: false
    });
  }

  hasHistoryEntry(url: string) {
    return !this._isMissingEntry(this.stateHistoryService.get(url));
  }

  _isMissingEntry(entry) {
    return _.isNull(entry) || _.isUndefined(entry) || entry == '';
  }

  _currentScreenDoesNotRequireLogin() {
    return this.router.urlService.path() == '/login' || this.router.urlService.path() == '/setpassword' || this.router.urlService.path() == '/authenticateToken' || this.router.urlService.path() == '/conference' || this.router.urlService.path() == '/candidateConference' || this.router.urlService.path() == '/candidateOutreach';
  }

  _currentUrlIsInvalid() {
    return this.$state.current.url == '^' && !this.router.urlService.url().includes('conference');
  }

  stateChange() {
    let entry, url;
    let poppedValue = this.preventCall.pop();
    if (!_.isUndefined(poppedValue) && !_.isNull(poppedValue) && poppedValue == 'stateChange') {
      return;
    }
    entry = {
      name: this.$state.current.name,
      params: this.$state.params
    };
    if (this.$state.current.url == '/login' || this.$state.current.url == '/setpassword' || this.$state.current.url == '/authenticateToken?a&t&cid&comp' || this.$state.current.url == '/conference?c&j&jm&t&mode&sh&ws&m' || this.$state.current.url == '/candidateConference?c&j&jm&t&mode&sh&ws&m') {
      // if(this.$state.current.url == '/setpassword' || this.$state.current.url == '/authenticateToken?a&t' || this.$state.current.url.toLowerCase().includes('conference')) {
      return this.router.urlService.url();
    }
    url = this.$state.current.url + "/" + (this.getGUIDForUniqueURL().substr(0, 8));
    this.stateHistoryService.set(url, entry);
    this.preventCall.push('locationChange');
    return this.router.urlService.url(url);
  }

  getGUIDForUniqueURL() {
    let s4;
    s4 = () => {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    };
    return "" + (s4()) + (s4()) + "-" + (s4()) + "-" + (s4()) + "-" + (s4()) + "-" + (s4()) + (s4()) + (s4());
  }
}
